export default (number: string | number): number => {
  return Math.abs(parseFloat((number || 0).toString()))
};
